module.exports = __webpack_public_path__ + "img/time.60e19dac.gif";